// extracted by mini-css-extract-plugin
module.exports = {"close":"styles_close__3la8b","alignBottom":"styles_alignBottom__2PRwY","modalContent":"styles_modalContent__3Ff7M"};